export const CLIENT_ID = '366265751142-k3ufp6k46j9q425umst0oe5t9eo5qcrn.apps.googleusercontent.com'
export const PROMPT_PARENT_ID = 'google-one-tap-container'